import React from 'react';
import { useDropzone } from 'react-dropzone';

import axios from 'helpers/axios';
import { Button, Container, TextInput, Title } from 'ui/components/styled';
import { UploadMessage, UploadWrapper, Wrapper } from './styles';
import { useToasts } from 'hooks';

const Logo = ({ getRootProps, getInputProps }) => (
  <Container mb="xxl">
    <Title variant="primary" fontSize="16px" mb="xs">
      Company logo
    </Title>
    <UploadWrapper {...getRootProps()} data-cy="drag-and-drop">
      <input {...getInputProps()} name="logo" />
      <UploadMessage>Drop your logo here or browse</UploadMessage>
    </UploadWrapper>
  </Container>
);

const AppName = ({ title, handleChange, handleUpdate }) => (
  <Container>
    <Title variant="primary" fontSize="16px" mb="xs">
      App Name
    </Title>
    <Container>
      <TextInput
        value={title}
        onChange={handleChange}
        placeholder="Name"
        maxWidth="250px"
        mb="xs"
      />
      <Button width="100px" onClick={handleUpdate}>
        Update
      </Button>
    </Container>
  </Container>
);

export default function CompanyBranding() {
  const [title, setTitle] = React.useState('');
  const { errorToast, successToast } = useToasts();
  const handleTitleChange = ({ currentTarget: { value } }) => {
    setTitle(value);
  };

  const handleTitleUpdate = async () => {
    if (!title) return;
    try {
      await axios.post('/branding/title', { title });
      successToast('App title updated successfully');
      setTimeout(() => {
        window.location.reload(false);
      }, 2000);
    } catch (e) {
      errorToast('Error while updating the title');
    }
  };

  const onDrop = React.useCallback(async (acceptedFiles) => {
    try {
      if (acceptedFiles && acceptedFiles[0]) {
        const file = acceptedFiles[0];
        const formData = new FormData();
        formData.append('logo', file);
        await axios.post('/branding/logo', formData, {
          headers: {
            'Content-Type': `multipart/form-data`,
          },
        });
        successToast('Logo updated successfully');
        setTimeout(() => {
          window.location.reload(false);
        }, 2000);
      }
    } catch (e) {
      errorToast('Error while uploading the logo');
    }
  }, []);

  const dropZone = useDropzone({
    onDrop,
    multiple: false,
  });

  return (
    <Wrapper>
      <Logo {...dropZone} />
      <AppName title={title} handleChange={handleTitleChange} handleUpdate={handleTitleUpdate} />
    </Wrapper>
  );
}
